import { useMemo } from 'react';
import { useTrafficQuality } from '@/api/hooks';
import { useAgent } from '@/auth/use-agent';
import type { TrafficQualityData } from '@/api/types';
import { ErrorNotice } from '@/ui/ErrorNotice';
import { Loading } from '@/ui/Loading';
import { Notice } from '@/ui/Notice';
import { ReportFrame } from '@/ui/ReportFrame';
import { dashboardDocument } from './dashboard-document';

function Report({ data }: { data: TrafficQualityData }) {
  const srcDoc = useMemo(() => dashboardDocument(data), [data]);
  return <ReportFrame title="Traffic quality" srcDoc={srcDoc} />;
}

export function TrafficQualityPage() {
  const { agent } = useAgent();
  // Hooks run before the admin check; the query itself stays off for an agent.
  const report = useTrafficQuality(agent.admin);

  if (!agent.admin) return <Notice>Traffic quality is for admins only.</Notice>;
  if (report.isPending) return <Loading what="traffic quality" />;
  if (report.error) return <ErrorNotice error={report.error} />;
  if (!report.data) {
    return <Notice>No traffic quality data yet: the first nightly snapshot has not been copied over.</Notice>;
  }
  return <Report data={report.data} />;
}
